"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var request_1 = __importDefault(require("../../request"));
var ContributionAmountInput_vue_1 = __importDefault(require("../form/ContributionAmountInput.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var __ = window.$lang;
var AmountsSettings = /** @class */ (function (_super) {
    __extends(AmountsSettings, _super);
    function AmountsSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "amounts-settings";
        _this.amounts = null;
        _this.amountsValues = null;
        return _this;
    }
    AmountsSettings.prototype.created = function () {
        request_1.default.amounts.all(this.updateAmounts);
    };
    Object.defineProperty(AmountsSettings.prototype, "settings", {
        get: function () {
            return this.$store.state.settings;
        },
        enumerable: true,
        configurable: true
    });
    AmountsSettings.prototype.onSettingsChanged = function () {
        var amountsValues = this.amountsValues || {};
        for (var _i = 0, _a = this.years; _i < _a.length; _i++) {
            var year = _a[_i];
            if (typeof amountsValues[year] === "undefined") {
                amountsValues[year.toString()] = {
                    "quarter1": 0,
                    "quarter2": 0,
                    "quarter3": 0,
                    "quarter4": 0
                };
            }
        }
        this.amountsValues = amountsValues;
    };
    Object.defineProperty(AmountsSettings.prototype, "years", {
        get: function () {
            var _a = this.settings, CONTRIBUTIONS_YEAR_START = _a.CONTRIBUTIONS_YEAR_START, CONTRIBUTIONS_YEAR_END = _a.CONTRIBUTIONS_YEAR_END;
            var results = [];
            for (var i = CONTRIBUTIONS_YEAR_START; i <= CONTRIBUTIONS_YEAR_END; i++) {
                results.push(i);
            }
            return results;
        },
        enumerable: true,
        configurable: true
    });
    AmountsSettings.prototype.updateAmounts = function (amounts) {
        var amountsValues = amounts;
        for (var _i = 0, _a = this.years; _i < _a.length; _i++) {
            var year = _a[_i];
            if (typeof amountsValues[year] === "undefined") {
                amountsValues[year.toString()] = {
                    "quarter1": 0,
                    "quarter2": 0,
                    "quarter3": 0,
                    "quarter4": 0
                };
            }
        }
        this.amountsValues = amountsValues;
        this.amounts = amounts;
    };
    AmountsSettings.prototype.submitForm = function () {
        var _this = this;
        request_1.default.amounts.update(this.amountsValues, function () {
            _this.$notification("success", __("Wysokości składek zostały zaktualizowane."));
        });
    };
    __decorate([
        vue_property_decorator_1.Watch("settings")
    ], AmountsSettings.prototype, "onSettingsChanged", null);
    AmountsSettings = __decorate([
        vue_class_component_1.default({
            components: { ContributionAmountInput: ContributionAmountInput_vue_1.default, VButton: VButton_vue_1.default }
        })
    ], AmountsSettings);
    return AmountsSettings;
}(vue_property_decorator_1.Vue));
exports.default = AmountsSettings;
